import React from 'react';
import PropTypes from 'prop-types';

const style = {
  color: 'rgb(51, 51, 51)',
  fontSize: '18px',
  fill: 'rgb(51, 51, 51)',
  textAlign: 'center',
  display: 'block',
  fontWeight: '600',
  borderBottom: '1px solid #ddd',
  padding: '7px',
};

const ChartBox = (props) => (
  <div className="box-border" id={`chrt-${props.id}`}>
    {props.title !== undefined && <div style={style}>{props.title}</div>}
    <div>{props.children}</div>
  </div>
);

ChartBox.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  id: PropTypes.string,
};

export default ChartBox;
